import { installPolyfills } from './polyfills'

await installPolyfills()
await import('./app')
